import Vue from 'vue';

import * as api from '../../api/index.js';

import indexItem from './indexItem.vue';
import indexItemList from './indexItemlist.vue';
import detailItem from './detailItem.vue';
import indexActivity from './indexActivity.vue';
import indexImages from './indexImages.vue';
import detailsLike from './detailsLike.vue';
import detailsClick from './detailsClick.vue';
import detailsComment from './detailsComment.vue';
import detailsNoneComment from './detailsNoneComment.vue';
// import detailsReply from './detailsReply.vue';
import my from './my.vue';
import myInfo from './myInfo.vue';

import detailsCounter from './detailsCounter.vue';

var componentList={
		indexActivity
	,	indexItem
	,	indexItemList
	,	detailItem
	,	indexImages
	,	detailsLike
	,	detailsClick
	,	detailsComment
	,   detailsNoneComment
	// ,	detailsReply
	,	my
	,	myInfo
	
	,   detailsCounter
};
for(var name in componentList){
	Vue.component('discover'+name.replace(/^\w/,function(word){
		return word.toLocaleUpperCase();
	}), componentList[name]);
}

export let concernEvent = function(memberId, data){
	api.discover.concern({
		data: {
			memberIds: memberId
		}
		, success(){
			maple.notice('关注成功!');
			data.hasConcerned = true;
		}
		,tgError:function(data){
			maple.notice('遇到一点小问题，稍后再试。')
		}
	});
};
export let notConcernEvent = function(memberId, data){
	api.discover.unconcern({
		data: {
			memberId: memberId
		}
		, success(){
			data.hasConcerned = false;
		}
	});
};